<template>
    <div>
        <h3 style="text-align: center">สลิปเงินเดือน</h3>
        <div class="row form-group">
            <div class="col-4 text-right">แผนก</div>
            <div class="col-6">
                <multiselect
                        :options="optionDepartment"
                        v-model="search.department"
                        label="department_name"
                        multiple
                        style="height: 100%"
                        :closeOnSelect="false"
                        select-label=""
                        deselectLabel=""
                        placeholder="แผนก"
                        track-by="id">
                </multiselect>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">พนักงาน</div>
            <div class="col-6">
                <multiselect
                        v-model="search.employee"
                        :options="optionEmployee"
                        label="name"
                        multiple
                        style="height: 100%"
                        :closeOnSelect="false"
                        placeholder="ค้นหาพนักงาน"
                        :show-labels="false"
                        :customLabel="employeeLabel"
                        track-by="id">
                </multiselect>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">เดือน</div>
            <div class="col-6">
                <multiselect
                        label="name"
                        placeholder="เลือกเดือน"
                        :options="optionMonth"
                        v-model="search.month"
                        track-by="value"
                        :searchable="false"
                        :close-on-select="true"
                        :show-labels="false"
                >
                </multiselect>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">วีค</div>
            <div class="col-6">
                <multiselect
                        label="name"
                        placeholder="เลือกวีค"
                        :options="optionWeek"
                        v-model="search.week"
                        track-by="value"
                        :searchable="false"
                        :close-on-select="true"
                        :show-labels="false"
                >
                </multiselect>
            </div>
        </div>
<!--        <div class="row form-group">-->
<!--            <div class="col-4 text-right">ภาษา</div>-->
<!--            <div class="col-6 row p-0 ml-3">-->
<!--                <div class="col-6">-->
<!--                    <input class="form-check-input" type="radio" value="th"-->
<!--                           v-model="search.lang"-->
<!--                           id="defaultCheck1">-->
<!--                    <label class="form-check-label" for="defaultCheck1">-->
<!--                        ไทย-->
<!--                    </label>-->
<!--                </div>-->
<!--                <div class="col-6">-->
<!--                    <input class="form-check-input" type="radio" value="mm"-->
<!--                           v-model="search.lang"-->
<!--                           id="defaultCheck2">-->
<!--                    <label class="form-check-label" for="defaultCheck2">-->
<!--                        พม่า-->
<!--                    </label>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
        <div class="col text-center">
            <button  type="button"
                     @click="submitData"
                     class="btn btn-success">
                <icon name="print" style="width: 25px"></icon>
                ตกลง
            </button>&nbsp;&nbsp;
            <button type="button"
                    @click="cancelData"
                    class="btn btn-outline-secondary">
                <icon name="times"></icon>
                ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    export default {
        name: "FilterSalaryModal",
        components:{
            Multiselect,
        },
        data(){
            return{
                search :{
                    date : [],
                    employee : [],
                    week : '',
                    month : '',
                    department : [],
                    // lang : 'th',
                },
                optionEmployee : [],
                optionDepartment : [],
                optionWeek : [
                    { name: 'วีค 1', value: '1'},
                    { name: 'วีค 2', value: '2' }
                ],
                optionMonth : [
                    { name: 'มกราคม', value: '1'},
                    { name: 'กุมภาพันธ์', value: '2'},
                    { name: 'มีนาคม', value: '3'},
                    { name: 'เมษายน', value: '4'},
                    { name: 'พฤษภาคม', value: '5'},
                    { name: 'มิถุนายน', value: '6'},
                    { name: 'กรกฎาคม', value: '7'},
                    { name: 'สิงหาคม', value: '8'},
                    { name: 'กันยายน', value: '9'},
                    { name: 'ตุลาคม', value: '10'},
                    { name: 'พฤศจิกายน', value: '11'},
                    { name: 'ธันวาคม', value: '12'}
                ],
            }
        },
        created() {
            this.getEmployeeAll();
            // this.$store.dispatch("Employee/setEmployee");
            this.getDepartmentAll();
        },
        methods:{
            employeeLabel(option){
                return `${option.employee_no} - ${option.name}`
            },
            getEmployeeAll(){
                this.$store.dispatch("Employee/getEmployeeAll").then(res=>{
                    this.optionEmployee = res;
                })
            },
            submitData(){
                if(this.search.department.length == 0 && this.search.employee.length == 0){
                    alert('กรุณาเลือกพนักงาน หรือแผนก');
                }else{
                    let employee_id = '';
                    let department_id = '';
                    this.search.employee.forEach((a,i)=>{
                        this.search.employee.length == i+1 ? employee_id = employee_id + a.employee_no:employee_id = employee_id + a.employee_no + ',';
                    })
                    this.search.department.forEach((a, i) => {
                        this.search.department.length == i + 1 ? department_id = department_id + a.id : department_id = department_id + a.id + ',';
                    })
                    let data = {
                        employee_no : employee_id,
                        week : this.search.week ? this.search.week.value : '',
                        month : this.search.month ? this.search.month.value : '',
                        department : department_id,
                        lang : '',
                    };
                    this.$emit("submit",data);
                }
            },
            cancelData(){
                this.$emit("submit",false);
            },
            getDepartmentAll(){
                this.$store.dispatch("Department/getAllDepartment").then(res=>{
                    this.optionDepartment = res;
                })
            },
        }
    }
</script>

<style scoped>

</style>
